import {
  AfterViewInit,
  Directive,
  Input,
  OnDestroy,
  inject, OnChanges,
  SimpleChanges, Output, EventEmitter,
} from '@angular/core';
import {MatOption, MatSelect} from '@angular/material/select';
import {Subscription} from 'rxjs';
import {AbstractControl} from "@angular/forms";

@Directive({
  selector: 'mat-option[selectAll]',
  standalone: true,
})
export class SelectAllDirective implements AfterViewInit, OnDestroy, OnChanges {
  @Input({ required: true }) allValues: any[] = [];
  @Output() trigger = new EventEmitter<null>();

  private _matSelect = inject(MatSelect);
  private _matOption = inject(MatOption);

  private _subscriptions: Subscription[] = [];

  private parentFormControl!: AbstractControl<any,any> | null;

  ngAfterViewInit(): void {
    const parentSelect = this._matSelect;
    this.parentFormControl = parentSelect.ngControl.control;

    this._subscriptions.push(
      parentSelect.optionSelectionChanges.subscribe((v) => {
        // For changing other option selection based on select all
        if (v.isUserInput && v.source.value == this._matOption.value) {
          if (v.isUserInput) {
            if (v.source.selected) {
              this.parentFormControl?.setValue(this.allValues);
              this._matOption.select(false);
            } else {
              this.parentFormControl?.setValue([]);
              this._matOption.deselect(false);
              this.trigger.emit();
            }
          }
        }
        // For changing select all based on other option selection
        if (v.isUserInput && v.source.value !== this._matOption.value) {
          if (this.parentFormControl?.value.length === this.allValues.length) {
            this._matOption.select(false);
          } else {
            this._matOption.deselect(false);
          }
        }

      })
    );

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['allValues']) {
      this._matOption.deselect(false);
      setTimeout(() => {
        if (this.parentFormControl?.value.length === this.allValues.length) {
          this._matOption.select(false);
        }
      });
    }
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach((s) => s.unsubscribe());
  }
}
